module.exports = __webpack_public_path__ + "static/img/20011 (1).35062ed.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20011 (1).webp
// module id = eGpx
// module chunks = 14